import BaseService from './BaseService';

class DashboardService extends BaseService {
    getDashboardData = () => this.get('/get-dashboard-data');
}

export default new DashboardService();
